import { AppSettings } from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';

export const awaitingReview = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post('/api/request-for-services', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const search = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`api/reports/request-for-services/search?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getListWorkOrderByRFSID = params => {
  // return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/request-for-services/${params.rfsId}/workOrders/?${ObjToParam(params)}`)
  //   .then((response) => {
  //     return MapResponse(response);
  //   }).catch((error) => {
  //     var response = error.response;
  //     return MapResponse(response);
  //   });
  return Jwt(AppSettings.GLOBAL_API_URL)
    .get(
      `/apiv1/request-for-services/${params.rfsId}/workOrders/?${ObjToParam(
        params
      )}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const approve = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post('/api/request-for-services/approve', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const close = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post('/api/request-for-services/close', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getByRFSID = (params, isLoading = true) => {
  // if (AppSettings.clientTypeValue === 'Subcontractor' || AppSettings.clientTypeValue === 'Homeowner') {
  return Jwt(AppSettings.GLOBAL_API_URL, isLoading, {
    headers: [{ key: 'Key', value: params }]
  })
    .get(`/apiv1/request-for-services/${params}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
  // } else {
  //   return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/request-for-services/${params}`)
  //     .then((response) => {
  //       return MapResponse(response);
  //     }).catch((error) => {
  //       var response = error.response;
  //       return MapResponse(response);
  //     });
  // }
};

export const getRFSEndpoint = params => {

  return Jwt(AppSettings.GLOBAL_API_URL, {
    header: [{key: 'Key', value: params }]
  })
    .get(`apiv1/request-for-services/request-electric-orientation-checklists/endpoints/${params}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateRFSWithoutChangeStatus = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(`/api/request-for-services/${params.refNo}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const signoffMultipleWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(
      `/api/request-for-services/${params.refNo}/close-work-orders`,
      params.param
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reportSelectListRegion = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`/api/reports/region-select-list?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reportSelectListMarket = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`/api/reports/market-select-list?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reportSelectListProject = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`/api/reports/project-select-list?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reportSelectListRequestType = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get('/api/reports/request-type-select-list', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reportSelectListLot = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`/api/reports/lot-select-list?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getRFSHistory = params => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .get(`/apiv1/histories/request-for-services/${params.refNo}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateRFSManageBy = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .patch(
      `/api/request-for-services/${params.refNo}/managed-by-users`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateRFSRequestType = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .patch(
      `/api/request-for-services/${params.refNo}/request-type`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

// HOMEOWNER

export const AddHomeownerRequest = params => {
  return Jwt(null, false, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .post(`${params.endpoint}/api/portal-homeowners/work-orders`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const signOffMultipleHomeownerWorkOrder = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .put(
      `${params.builderHost}/api/portal-homeowners/${
        params.param.refNo
      }/close-work-orders`,
      params.param.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const exportRFSList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, { responseType: 'blob' })
    .get(`/api/reports/export/request-for-services?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response, true);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reassignMultipleRFS = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put('/api/request-for-services/managed-by-users', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};
//API for printPreviewRFS
export const printPreviewRFS = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`/api/request-for-services/print-preview/${params.refNo}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const fetchRequestElectricOrientationCheckList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`/api/request-electric-orientation-checklists/${params.refNo}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const fetchRequestElectricOrientationCheckList2 = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`/api/electronic-punch-lists/get-or-create?refNo=${params.refNo}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getCheckEPLIsAvailable = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`/api/electronic-punch-lists/is-allow-to-generate-epl-form/${params.refNo}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const eocTemplateHomeowner = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .post(`${params.endpoint}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const eocSubmitTemplateHomeowner = params => {
  return Jwt(null, true , {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .post(`${params.endpoint}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const homeownerRFSSetupAWS = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .post(`${params.builderHost}/api/aws/s3/credentials`, params.param)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

//print EOC template
export const printEOCTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`/api/request-electric-orientation-checklists/${params.refNo}/print-preview`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const printEOFTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('/api/electronic-punch-lists/print', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const printEPLTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, { responseType: 'blob' })
    .post('/api/electronic-punch-lists/print_epl', params)
    .then(response => {
      return MapResponse(response, true);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

//signature requestEOC
export const requestSignatureEOC = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`/api/request-electric-orientation-checklists/${params.refNo}/signatures`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

//signature checklist requestEOC

export const requestCheckListSignatureEOC = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`/api/request-electric-orientation-checklists/${params.refNo}/checklists/signatures`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

//checklist approval request for service EOC template

export const requestCheckListsApprovalEOC = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`/api/request-electric-orientation-checklists/${params.refNo}/checklists/approvals`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

// submit EOC template

export const submitElectricOrientationCheckLists = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('/api/request-electric-orientation-checklists/submit', params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const submitElectricOrientationCheckLists2 = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('/api/electronic-punch-lists/submit', params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

//rfs upload s3

export const uploadS3Signature = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('/api/aws/s3/credentials', params)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      const response = error.response;
      return MapResponse(response);
    });
};

//save lot document
export const saveEocFormToLotDocument = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`/api/request-electric-orientation-checklists/${params.refNo}/save-to-lot-document`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

//send email EOC
export const sendEOCTemplateEmail = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('/api/request-electric-orientation-checklists/send-email', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const sendEPLTemplateEmail = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('/api/electronic-punch-lists/send-email', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const updateWOReassignValue = params => {
  console.log("Parmas", params)
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.RefNos[0] }]
  }).put('/api/work-orders/ReassignMultipleWorkOrder', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getEmailPrimaryHomeowner = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`api/request-electric-orientation-checklists/${params.refNo}/email-of-primary-home-owner`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const fetchCreatedBy = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`/api/reports/createdby_users-select-list?ProjectIds=&MarketIds=&LotIds=&CreatedBy=`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

// export const fetchAverageAgeAPI = params => {
//   return Jwt(AppSettings.CURRENT_SITE_URI, true)
//     .get(`/api/prioritized-contacts/get-rfs-average-age`)
//     .then(response => {
//       return MapResponse(response);
//     })
//     .catch(error => {
//       const response = error.response;
//       return MapResponse(response);
//     });
// };
export const getRFSREviewDate = params =>{
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
  .patch(`api/request-for-services/${params.rfsId}/rfs-review-date-update`,params.data)
  .then(response => {
    return MapResponse(response);
  })
  .catch(error => {
    const response = error.response;
    return MapResponse(response);
  });
}



// WEBPACK FOOTER //
// ./src/Request-Services/api.js